module.exports = __webpack_public_path__ + "static/img/3dzhajinhua.90b3815.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/3dzhajinhua.png
// module id = cSTo
// module chunks = 0